(() => {
  const app = window.TWLuxuryHome;
  if (!app) return;

  app.register('[data-twlh-entry]', (root, api) => {
    const actions = root.querySelector('.twlh-entry__copy .twlh-actions');
    const values = new Map();
    let actionsInteractive = null;

    const setValue = (property, value) => {
      const next = value.toFixed(5);
      if (values.get(property) === next) return;
      values.set(property, next);
      root.style.setProperty(property, next);
    };

    const setActionsInteractive = (interactive) => {
      if (!actions || actionsInteractive === interactive) return;
      actionsInteractive = interactive;
      actions.toggleAttribute('inert', !interactive);
      actions.setAttribute('aria-hidden', String(!interactive));
    };

    return {
      update({ reduced }) {
        const disabled = reduced || root.dataset.motion === 'false';
        const value = disabled ? 0 : api.progress(root, 'signature');
        const object = disabled ? 1 : .7 + api.smoothstep(.02, .34, value) * .3;
        const light = disabled ? 0 : api.smoothstep(.12, .72, value) * (1 - api.smoothstep(.82, 1, value));

        setValue('--entry-p', value);
        setValue('--entry-object', object);
        setValue('--entry-light', light);

        /* Überschrift und Erklärung bleiben immer im Accessibility Tree.
           Nur die visuell nahezu verschwundenen Handlungen verlassen vorübergehend
           die Tastaturreihenfolge. */
        const actionLimit = api.compact.matches ? .84 : .91;
        setActionsInteractive(disabled || value < actionLimit);
      },
      destroy() {
        values.clear();
        ['--entry-p', '--entry-object', '--entry-light'].forEach((property) => root.style.removeProperty(property));
        actions?.removeAttribute('inert');
        actions?.removeAttribute('aria-hidden');
      }
    };
  });
})();
